import { store } from "../redux"
import { AppActions } from "../redux/appSlice"

export const invalidateStripeProductsCache = () => {
  try {
    store.dispatch(AppActions.invalidateStripeProductsCache())
  } catch (error) {
    console.error("Failed to invalidate Stripe products cache:", error)
  }
}

export const StripeCache = {
  invalidateAfterSubscriptionChange: invalidateStripeProductsCache,
  invalidateAfterCheckout: invalidateStripeProductsCache,
  invalidateAfterPayAsYouGo: invalidateStripeProductsCache,
  invalidateAfterBillingPortal: invalidateStripeProductsCache,
  invalidate: invalidateStripeProductsCache,
}
